import { useRef } from "react";
import { Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const FileInput = ({ file, onFile, accept, testid, className, label = "Seleccionar archivo" }) => {
  const ref = useRef(null);
  return (
    <div className={cn("flex flex-wrap items-center gap-x-3 gap-y-1.5 min-w-0", className)}>
      <input ref={ref} type="file" accept={accept} className="hidden" data-testid={testid}
        onChange={(e) => { onFile(e.target.files?.[0] || null); e.target.value = ""; }} />
      <Button type="button" variant="secondary" size="sm" className="gap-2 shrink-0" onClick={() => ref.current?.click()} data-testid={testid ? `${testid}-btn` : undefined}>
        <Paperclip className="h-4 w-4" /> {label}
      </Button>
      <span className={cn("text-sm truncate max-w-full", file ? "text-foreground" : "text-muted-foreground")} data-testid={testid ? `${testid}-name` : undefined}>
        {file ? file.name : "Ningún archivo seleccionado"}
      </span>
    </div>
  );
};
